import { Text } from '@foss/legion-ui'
import { CodeBlock } from '../content/CodeBlock'
import { Workspace } from '../workspace/Workspace'
import prose from '../content/Prose.module.css'

const ROWS: [string, string, string][] = [
  ['xs', '0', 'Phones, portrait.'],
  ['sm', '600', 'Phones landscape, small tablets.'],
  ['md', '960', 'Tablets. The docs nav becomes a drawer below this.'],
  ['lg', '1280', 'Laptops.'],
  ['xl', '1920', 'Large desktops.'],
]

export function Breakpoints() {
  return (
    <div className={prose.prose} data-testid="breakpoints-page">
      <section className={prose.section}>
        <Text>
          The breakpoint table is Material-UI v4&apos;s, unchanged, so{' '}
          <code>theme.breakpoints.down(&apos;xs&apos;)</code> ports across
          without recalculating anything.
        </Text>
        <div className={prose.tableWrap}>
          <table className={prose.table}>
            <thead>
              <tr>
                <th>Key</th>
                <th>Min width</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map(([key, width, note]) => (
                <tr key={key}>
                  <td>
                    <code>{key}</code>
                  </td>
                  <td>
                    <code>{width}px</code>
                  </td>
                  <td>{note}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <CodeBlock label="Usage">{`import { useBreakpoint, useMediaQuery } from '@foss/legion-ui'

const key = useBreakpoint()                    // 'xs' | 'sm' | 'md' | 'lg' | 'xl'
const compact = useMediaQuery({ down: 'md' })  // boolean`}</CodeBlock>
      </section>

      <section className={prose.section}>
        <Text variant="heading" as="h2">
          Live
        </Text>
        <Text>Resize the window and watch this update.</Text>
        <Workspace
          name="Breakpoints"
          source={`const key = useBreakpoint()
const compact = useMediaQuery({ down: 'md' })
return (
  <Stack gap={2} align="start">
    <Text variant="mono">breakpoint: {key}</Text>
    <Text variant="mono" tone="muted">down(md): {String(compact)}</Text>
  </Stack>
)`}
        />
      </section>
    </div>
  )
}
